import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

type ModelBioData = {
  name?: string;
  provider?: string;
  modelId?: string;
  blurb?: string;
};

@Component({
  selector: 'app-model-bio-detail-dialog',
  templateUrl: './model-bio-detail-dialog.component.html',
  styleUrls: ['./model-bio-detail-dialog.component.scss']
})
export class ModelBioDetailDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ModelBioDetailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModelBioData
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
